import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@fontsource-variable/inter/wght.css'
import './index.css'
import App from './App.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

// PWA-3 (orden 6c634438): el cliente universal es PWA instalable SOLO en hosts de cliente.
// El Arquitecto (host de la plataforma) NO se instala — es la herramienta del operador.
// El mismo build sirve a ambos; la instalabilidad se decide por host (cero hardcode de cliente).
const HOST_PLATAFORMA = 'arquitecto.aarpia-lite.es'
if ('serviceWorker' in navigator && typeof window !== 'undefined') {
  const host = window.location.hostname
  const esCliente = host !== HOST_PLATAFORMA && !host.startsWith('localhost') && !/^\d+\./.test(host)
  if (esCliente) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js').catch(() => { /* best-effort */ })
    })
  } else {
    // En el Arquitecto/dev: limpiar cualquier SW que se hubiera registrado antes.
    navigator.serviceWorker.getRegistrations().then((rs) => rs.forEach((r) => r.unregister())).catch(() => {})
  }
}
